import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getGeoValueByType } from '../../../packages/JsonQuery';
import { IJsonQueryHighway } from '../../../packages/api-models/common/json_query';

export const selectHighwayIds = createSelector(selectJsonQuery, jsonQuery => {
  const highways = getGeoValueByType<IJsonQueryHighway>('highway')(jsonQuery);

  return highways ? highways.map(({ id }) => id) : [];
});
